export const ADD_LOGBOOK_ENTRY = 'logbook.addLogbookEntry';
